import React from 'react';
import { PortalHeader } from '2kit';

const Header: React.FunctionComponent = () => (
	<PortalHeader />
);

export default Header;
